// Fixed public addresses of third-party sites the app links OUT to. Not API/WS bases (those come from injected
// __ENV__), so each carries the lint exemption the venmo deep link does, with the reason.

/** An artist's page on Spotify. Spotify's developer policy requires a link back wherever its metadata or artwork
 *  is shown, so every surface drawing a Spotify-sourced act or comparable links here. */
export function spotifyArtistUrl(spotifyArtistId: string): string {
  // eslint-disable-next-line no-restricted-syntax -- external vendor link target, not an app base
  return `https://open.spotify.com/artist/${encodeURIComponent(spotifyArtistId)}`;
}

/** A track's page on Spotify. */
export function spotifyTrackUrl(spotifyTrackId: string): string {
  // eslint-disable-next-line no-restricted-syntax -- external vendor link target, not an app base
  return `https://open.spotify.com/track/${encodeURIComponent(spotifyTrackId)}`;
}

/** The band's Bandsintown for Artists dashboard — where they add the event themselves. We no longer call
 *  Bandsintown at all (its terms forbid commercial use), so "add to Bandsintown" is copy-the-details-and-open. */
// eslint-disable-next-line no-restricted-syntax -- external vendor link target, not an app base
export const BANDSINTOWN_DASHBOARD_URL = "https://artists.bandsintown.com/";

/** The YouTube player for a stored video id (Settings › Tutorials, ART-293). The privacy-enhanced host sets no cookie
 *  until the viewer presses play; `playsinline` keeps the iOS wrapper from forcing full screen. */
export function youTubeEmbedUrl(videoId: string, opts: { autoplay?: boolean } = {}): string {
  const autoplay = opts.autoplay ? "&autoplay=1" : "";
  // eslint-disable-next-line no-restricted-syntax -- external vendor embed, not an app base
  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?rel=0&playsinline=1${autoplay}`;
}

/** A video's still thumbnail (480×360, letterboxed to 16:9 by YouTube). Exists for every public video. */
export function youTubeThumbnailUrl(videoId: string): string {
  // eslint-disable-next-line no-restricted-syntax -- external vendor image, not an app base
  return `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`;
}

/** A video's ordinary watch page on YouTube. */
export function youTubeWatchUrl(videoId: string): string {
  // eslint-disable-next-line no-restricted-syntax -- external vendor link target, not an app base
  return `https://www.youtube.com/watch?v=${encodeURIComponent(videoId)}`;
}

/** An Instagram profile, by handle (the /apply review compares the connected account with the listed one). */
export function instagramProfileUrl(handle: string): string {
  // eslint-disable-next-line no-restricted-syntax -- external vendor link target, not an app base
  return `https://instagram.com/${encodeURIComponent(handle.replace(/^@/, ""))}`;
}
